<template>
    <div id="pinPage">
        <div class="d-flex flex-column rounded align-items-center text-center py-5 px-lg-5 px-3 bg-white">
            <img alt="" src="/img/hcpay/hc-icon.svg" class="img-responsive mb-4" style="height:auto;width:2.5rem">
            <span class="font-md font-weight-bold text-capitalize text-gray-dk mb-3">{{EnumLabels.ENTR_YOUR_PIN}}</span>
            <span class="font-xs text-secondary">{{EnumLabels.PIN_HINT}}</span>
            <div class="col-lg-8 col-xs-12 d-flex flex-column align-items-center">
                <div class="form-group custom-input-group mt-4">
                <div class="pin-code">
                        <input type="password" 
                            maxlength="1" 
                            data-index="0"
                            ref="input-0"
                            v-on:keypress="NumbersOnly"
                            @input="focusNextOncePopulated($event, 1)"
                            @change="pinOneInput"
                            :style="pinBoxColor ? 'border-color: #E11931' : ''"
                            v-model="pin1"
                            autofocus
                        >
                        <input type="password" 
                            data-index="1"
                            ref="input-1"
                            v-on:keypress="NumbersOnly"
                            @input="focusNextOncePopulated($event, 1)"
                            maxlength="1"
                            @change="pinTwoInput"
                            :style="pinBoxColor ? 'border-color: #E11931' : ''"
                            v-model="pin2"
                        >
                        <input type="password"
                            data-index="2"
                            ref="input-2"
                            v-on:keypress="NumbersOnly"
                            @input="focusNextOncePopulated($event, 1)" 
                            maxlength="1"
                            @change="pinThreeInput"
                            :style="pinBoxColor ? 'border-color: #E11931' : ''"
                            v-model="pin3"
                        >
                        <input type="password" 
                            data-index="3"
                            ref="input-3"
                            v-on:keypress="NumbersOnly"
                            @input="focusNextOncePopulated($event, 1)"
                            maxlength="1"
                            @change="pinFourInput"
                            :style="pinBoxColor ? 'border-color: #E11931' : ''"
                            v-model="pin4"
                        >
                    </div>
                </div>
                <pulse-loader :loading="loading" :color="'#C8102E'" :size="'0.5rem'"></pulse-loader>
                <div v-if="invalidAttempt" class="attempt-invalid">{{ this.errorMessage }}</div>
                <div class="flex d-flex justify-content-center message-body mb-4">
                    <div class="float-left">
                        <img alt="" src="/img/hcpay/input-error-orange-icon.svg" class="img-responsive">
                    </div>
                    <div class="floaf-right">
                        <span class="text-secondary">
                            <small>Never share your PIN with anyone</small>
                        </span>
                    </div>
                </div>
                <pin-image id="pinImage"/>
                <button 
                    type="button" 
                    id="mobileSubmitBtn" 
                    @click="submit" 
                    class="btn btn-block rounded-lg font-sm text-capitalize py-2 mt-3 mb-5" 
                    :class="$v.pin1.$dirty && $v.pin2.$dirty && $v.pin3.$dirty && $v.pin4.$dirty && 
                    !$v.pin1.$error && !$v.pin2.$error && !$v.pin3.$error && !$v.pin4.$error ? 'btn-success' : 'btn-secondary text-gray-dk'" 
                    :disabled="!$v.pin1.$dirty || ($v.pin1.$dirty && $v.pin1.$error) ||
                    !$v.pin2.$dirty || ($v.pin2.$dirty && $v.pin2.$error) ||
                    !$v.pin3.$dirty || ($v.pin3.$dirty && $v.pin3.$error) ||
                    !$v.pin4.$dirty || ($v.pin4.$dirty && $v.pin4.$error)"
                    modalTrigger
                >
                    Verify
                </button>
                <cancel-request-opg eventName="'web_pin_cancel_go_back'" id="mobileBackToStore"></cancel-request-opg>    
            </div>
        </div>
        <div class="d-flex flex-column rounded align-items-center text-center py-4 px-3 bg-white mt-2">
            <download-opg-v3 class="px-4" google-play-id="loginGooglePlayBtn" qr-code-id="loginQRCode" />
        </div>
    </div>
</template>
<script>
    import { analyticsDirective } from '../directives/analytics.js';
    import { ERROR } from '../mixins/error_codes.js';
    import {required} from 'vuelidate/lib/validators'
    import pinCodeImage from "../components/pin_image.vue"
    import { EnumLabels } from '../enums/CommonString.js';
    
    
    const validNumber = (value) => (/^\d*\.?\d*$/).test(value)
    export default {
        components: {
            pinCodeImage
        },
        data(){
            return {
                EnumLabels,
                pin1:'',
                pin2:'',
                pin3:'',
                pin4:'',
                loading:false,
                disabled: true,
                invalidAttempt: false,
                pinBoxColor: false,
                errorMessage: '',
                detail: false,
            }
        },
        validations: {
            pin1: {
                required,
                validNumber
            },
            pin2: {
                required,
                validNumber
            },
            pin3: {
                required,
                validNumber
            },
            pin4: {
                required,
                validNumber
            }
        },
        methods:{
            NumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            focusNextOncePopulated(event, max) {
                if (event.target.value.length === max) {
                    const nextElement = this.$refs[`input-${Number(event.target.dataset.index) +1}`]
                    if (nextElement) nextElement.focus()
                }
            },
            pinOneInput(event) {
                let val = event.target.value;
                if(this.pin1 != '' && val.trim() == '') {
                    this.pin1 = val.trim();
                }else if (/^\d+$/.test(val)) {
                    this.pin1 = val;
                } else {
                    event.target.value = this.pin1;
                    return false;
                }
            },
            pinTwoInput(event) {
                let val = event.target.value;
                if(this.pin2 != '' && val.trim() == '') {
                    this.pin2 = val.trim();
                }else if (/^\d+$/.test(val)) {
                    this.pin2 = val;
                } else {
                    event.target.value = this.pin2;
                    return false;
                }
            },
            pinThreeInput(event) {
                let val = event.target.value;
                if(this.pin3 != '' && val.trim() == '') {
                    this.pin3 = val.trim();
                }else if (/^\d+$/.test(val)) {
                    this.pin3 = val;
                } else {
                    event.target.value = this.pin3;
                    return false;
                }
            },
            pinFourInput(event) {
                let val = event.target.value;
                if(this.pin4 != '' && val.trim() == '') {
                    this.pin4 = val.trim();
                }else if (/^\d+$/.test(val)) {
                    this.pin4 = val;
                } else {
                    event.target.value = this.pin4;
                    return false;
                }
            },
            changeView(view) {
                this.$root.$data.view = view;
            },
            submit() {
                this.$dialog.alert('', {
                    view: 'loader',
                    html: true,
                    customClass: 'dialog-sm',
                });

                var pinData = {
                    accountRequest:{
                        // User Agent data
                        os: this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                        browser: this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                        ip: this.$root.transaction.ipAddress,
                        sessionReferenceId: this.$root.$data.transaction.referenceNumber,
                        phone: this.$root.$data.analyticsData.phone,
                        userAgent: this.$root.$data.analyticsData.userAgent,
                    },
                    tid : this.$root.$data.tid,
                    username : this.$root.$data.account.username,
                    pin : this.pin1 +''+ this.pin2 +''+ this.pin3 +''+ this.pin4,
                    checkPrivacyPolicy: this.$root.$data.account.checkPrivacyPolicy,
                    checkAcceptableUsePolicy: this.$root.$data.account.checkAcceptableUsePolicy
                }

                let g4Params = {
                    'userId': this.$root.$data.account.userId,
                    'cuid': this.$root.$data.account.cuid,
                    'ip': this.$root.transaction.ipAddress,
                    'user_agent': this.$root.$data.analyticsData.userAgent,
                    'phone': this.$root.$data.analyticsData.phone,
                    'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                    'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                    'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
                    'transaction_reference': this.$root.$data.transaction.referenceNumber,
                }       
                this.$root.triggerG4Event('web_pin_click_verify',g4Params)   
                
                axios
                    .post("hcpay/user/validation", pinData)
                    .then(async response => {
                        this.newAccount = false;
                        if(response.data.response.users.length > 1) {
                            this.cancelRequest(this.$root.$data.tid);
                        } else {
                            this.confirmPayment(this.newAccount, response.data.response.analyticsId);
                        }
                    }).catch((error) => {
                        const errMessage = String(error.response.data.message).toLowerCase();
                    
                        if (errMessage === "maximum attempts reached") {
                            this.maxAttemptReached(this.$root.$data.tid);
                        } else if (errMessage === "payment_option_unavailable") {
                            this.noPaymentOption();
                        } else if (errMessage === "insufficient balance") {
                            this.pin1 = "";
                            this.pin2 = ""; 
                            this.pin3 = "";
                            this.pin4 = "";
                            this.invalidAttempt = true;
                            this.pinBoxColor = true;
                            this.errorMessage = "Insufficient balance to proceed the transaction.";
                            this.noPaymentOption();
                        } else {
                            this.pin1 = "";
                            this.pin2 = ""; 
                            this.pin3 = "";
                            this.pin4 = "";
                            this.invalidAttempt = true;
                            this.pinBoxColor = true;
                            this.errorMessage = "You have entered the wrong PIN.";
                            let g4Params = {
                                'userId': this.$root.$data.account.userId,
                                'cuid': this.$root.$data.account.cuid,
                                'ip': this.$root.transaction.ipAddress,
                                'user_agent': this.$root.$data.analyticsData.userAgent,
                                'phone': this.$root.$data.analyticsData.phone,
                                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                                'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
                                'transaction_reference': this.$root.$data.transaction.referenceNumber,
                            }       
                            this.$root.triggerG4Event('err_incorrect_pin',g4Params)   
                        }
                    }).finally(() => {
                        window.dispatchEvent(new CustomEvent("loading", {
                            detail: false
                        }));
                    })
            },
            confirmPayment(newAccount, analyticsId) {
                axios
                .post("hcpay/confirm/payment?tid=" + this.$root.$data.tid + "&analyticsId=" + analyticsId)
                .then(response => {
                        if(newAccount) {
                            this.changeView('welcome');
                        } else {
                            this.changeView('verify-identity');
                        }
                }).catch(error => {
                    //this.cancelRequest(this.$root.$data.tid);
                    this.changeView('generic-error');
                    this.invalidAttempt = true;
                }).finally(() => {
                    window.dispatchEvent(new CustomEvent("loading", {
                        detail: false
                    }));
                })
            },
            noPaymentOption() {
                window.dispatchEvent(new CustomEvent("loading", { detail: false }));
                this.changeView('leads-gen');
            },
            maxAttemptReached(transcationId) {
                axios
                    .post("hcpay/cancel_request?tid=" + transcationId)
                    .finally(() => {
                        window.dispatchEvent(new CustomEvent("loading", { detail: false }));
                        this.changeView('account-block');
                    });
            },
            cancelRequest(transcationId) {
                var vm = this;
                axios
                .post("hcpay/cancel_request?tid=" + transcationId)
                .then(response => {
                    this.changeView('cancel-page');
                })
                .catch(error => {
                    vm.$root.error = 'TECHNICAL_PROBLEM';
                });
            }
        },
        directives: {
            'analytics' : analyticsDirective
        },
        watch: {
            pin1: {
                handler: function() {
                    this.$v.pin1.$reset();
                    this.loading = true;
                    setTimeout(() => {
                        this.$v.pin1.$touch();
                        this.loading = false;
                    },1500);
                }
            },
            pin2: {
                handler: function() {
                    this.$v.pin2.$reset();
                    this.loading = true;
                    setTimeout(() => {
                        this.$v.pin2.$touch();
                        this.loading = false;
                    },1500);
                }
            },
            pin3: {
                handler: function() {
                    this.$v.pin3.$reset();
                    this.loading = true;
                    setTimeout(() => {
                        this.$v.pin3.$touch();
                        this.loading = false;
                    },1500);
                }
            },
            pin4: {
                handler: function() {
                    this.$v.pin4.$reset();
                    this.loading = true;
                    setTimeout(() => {
                        this.$v.pin4.$touch();
                        this.loading = false;
                    },1500);
                }
            },
        },
        created() {
            this.$root.$data.account.type = 'PHONE';
            this.$root.$data.previousView = 'mobile';

            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('web_pin_page',g4Params)   
        }
    }
</script>
<style scoped>
    small {
        font-size: 12px;
    }
    .errorIcon {
        height: auto;
        width: 1.5rem;
        position: absolute;
        right: 0.5rem;
        bottom: 0.825rem;
    }
    .message-body {
        margin: auto;
        width: 100%;
    }
    .float-left {
        float: left;
        width: 10%;
        border: 1px solid transparent;
    }
    .float-right {
        float: right;
        width: 90%;
        border: 1px solid transparent;
    }
    .pin-code{ 
        padding: 0; 
        margin: 0 auto; 
        display: flex;
        justify-content:center;
    
    }
    .pin-code input { 
        border: none; 
        text-align: center; 
        width: 48px;
        height: 48px;
        font-size: 36px; 
        background-color: #fff;
        margin-right:5px;
        border-radius: 12px;
        border: 1px solid #40404099;
    } 
    .pin-code input:focus { 
        border: 2px solid #49B672;
        outline:none;
    } 
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .attempt-invalid {
        color: #E11931;
        font-size: 12px;
    }
</style>